/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectsStatus = typeof ListProjectsStatus[keyof typeof ListProjectsStatus] | null;


export const ListProjectsStatus = {
  active: 'active',
  archived: 'archived',
} as const;
